// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__198w8","box":"WorkspacesBox_box___mGe7","node":"WorkspacesBox_node__2kzhW"};